module.exports = __webpack_public_path__ + "img/Fiche chargé data.7999a34a.jpg";